export enum TourName {
  ONBOARDING = 'onboarding',
  WELCOME = 'welcome',
}

export enum TourIdKey {
  USER_ID = 'userId',
  STUDENT_ID = 'studentId',
}
